<template>
  <div
    id="farmapremium-agreement"
  />
</template>

<script>
import { useMicros } from '@/composables'
import * as config from '@/dashboards'
import { Channel, piniaStoreModules } from 'frontendcommon-3'
import { storeToRefs, getActivePinia } from 'pinia'
import { useShellStore } from '@/store'
let isLoaded = false

export default {
  inheritAttrs: false,
  setup () {
    // shell store
    const shellStore = useShellStore()
    const { tokens, userInfo } = storeToRefs(shellStore)

    // common store
    const pinia = getActivePinia()
    const commonStore = piniaStoreModules.useCommon(pinia)
    const commonState = commonStore.$state

    const micro = useMicros()
    return { micro, commonState, tokens, userInfo }
  },
  data () {
    return {
      isMounted: false,
      isLoading: false
    }
  },
  methods: {
    async loadMicro () {
      try {
        this.isLoading = true
        if (!isLoaded) await this.micro.loadMicro('agreement', true)
        isLoaded = true
      } finally {
        this.isLoading = false
      }
    },
    async mountMicro () {
      try {
        await this.loadMicro()
        if (!this.isMounted) {
          // Create controller instance
          this.$agreement = new window.AgreementModal({ ...this.$attrs })
          // Mount component
          this.$agreement.mount(
            '#farmapremium-agreement',
            this.commonState,
            this.tokens,
            config,
            this.userInfo
          )
          this.isMounted = true
        }
      } catch (error) {
        Channel.emitAddServerError('No se ha podido cargar el panel de contratación.')
        console.error(error)
      }
    },
    async refresh () {
      return this.$agreement?.refresh()
    }
  },
  created () {
    this.mountMicro()
  },
  beforeUpdate () {
    this.$agreement?.set(this.$attrs)
  },
  beforeUnmount () {
    this.$agreement?.destroy()
    this.$agreement = null
  }
}
</script>
